
      import VanillaTilt from "vanilla-tilt";
      // Defer VanillaTilt to prevent main thread blocking on initial render
      window.addEventListener('load', () => {
        VanillaTilt.init(document.querySelectorAll(".tilt"), {
          max: 25,
          speed: 400
        });
      });
    